import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// API helpers for funding (tipping) an artist. The fee and what the artist receives always come from the server.
const url = (path) => `${API_BASE_URL}/v1/fan-tip/${path}`;
const config = (extra = {}) => ({ headers: { token: getAuthToken(), "Content-Type": "application/json" }, timeout: 20000, ...extra });
const result = (response) => response.data?.result;

export const fanTipApi = {
  // -> { artist, presets, min_amount, max_amount, currency, message_max, simulation_available, quote: { tip, processing_fee, artist_receives } | null }
  preview: (artistSlug, amount) => axios.get(url("preview"), config({ params: { artist_slug: artistSlug, ...(amount ? { amount } : {}) } })).then(result),
  // { artist_slug, amount, message } -> { tip_id, payment_intent_id, client_secret, quote }
  start: (body) => axios.post(url("start"), body, config()).then(result),
  // Test environments only: { artist_slug, amount, message, outcome: "success" | "declined" } -> { status, tip }; 402 when declined.
  simulate: (body) => axios.post(url("simulate"), body, config()).then(result),
  // { payment_intent_id } -> { status: "succeeded" | "pending", tip }; 402 when the payment failed.
  confirm: (body) => axios.post(url("confirm"), body, config({ timeout: 30000 })).then(result),
};
